import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/${number | ':jobId'}/subjobs`;

export const ROUTE: RouteDefinition = `${baseRoute}/:jobId/subjobs`;

export const URL = (jobId: number): RouteDefinition => `${baseRoute}/${jobId}/subjobs`;
